module.exports = __webpack_public_path__ + "static/media/empty-product.9c1d1cd6.svg";